var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-center",
          style: { "min-height": _vm.mH }
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "primary", size: _vm.size }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }